import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import automationsRoutes from './automations/automations.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as contentTemplateRoutes } from './contentTemplates/contentTemplates.routes';
import whatsappFlowsRoutes from './whatsapp_flows/whatsappFlows.routes';
import { routes as whatsappTemplatesRoutes } from './whatsappTemplates/whatsappTemplates.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import OnboardingWizard from 'v3/views/onboarding/OnboardingWizard.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...contentTemplateRoutes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...automationsRoutes.routes,
        ...whatsappFlowsRoutes.routes,
        ...whatsappTemplatesRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'account_onboarding',
      meta: {
        permissions: ['administrator'],
      },
      component: OnboardingWizard,
    },
  ],
};
